// extracted by mini-css-extract-plugin
module.exports = {"multipleEntitySelect":"LFXpTT","title":"RogX2H","active":"Y8HZu3"};